export default __webpack_public_path__ + "static/media/milestone 1.d18a51cf.svg";